import LogicVariableTable from './LogicVariableTable';
import { LogicVariableTableProps, LogicVariableTableValueProps } from './types';

export type { LogicVariableTableProps, LogicVariableTableValueProps };
export default LogicVariableTable;
